import type { EntitledEntity, EntitledEntityInput } from 'generated/gql';
import { pick } from 'lodash';

export const mapEntitledEntityToEntitledEntityInput = (
  entitledEntity: EntitledEntity,
): EntitledEntityInput => ({
  ...pick(entitledEntity, ['id', 'email', 'entitlement']),
  temporary: !!entitledEntity.temporaryAccessExpiration,
});
